require([
    'root/Base/Js/Vendor/PictureFill',
    'root/Assets/Js/Templates',
    'jquery'
], function() {
    'use strict';


});
define("root/Assets/Templates/Container/Threepictures/Js/Threepictures", function(){});

